import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; 
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./screens/home/Home";
import './App.css'; // Important for layout styles
import AboutUs from "./screens/about-us/Aboutus";
import Products from "./screens/products/Products";
import ContactUs from "./screens/contact-us/Contactus";

import IndustriesWeServe from "./screens/industriesWeServe/IndustriesWeServe";
import Salts from "./screens/products/productTypes/salts/Salts";
import Minerals from "./screens/products/productTypes/minerals/Minerals";
import Chemicals from "./screens/products/productTypes/chemicals/Chemicals";
import Sitemap from "./screens/sitemap/Sitemap";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import WhatsAppButton from "./components/whatsapp/WhatsAppButton";
import useMetaTags from "./hooks/useMetaTags";

function DynamicSeoManager() {
  useMetaTags();
  return null;
}

function App() {
  return (
    <Router>
      <DynamicSeoManager />
      <div className="app-wrapper">
        <Header />
        <ScrollToTop/>
        <main className="main-content">
          <Routes> 
            <Route path="/" element={<Home />} />  
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/industriesWeServe" element={<IndustriesWeServe />} />
            <Route path="/salts" element={<Salts />} />
            <Route path="/minerals" element={<Minerals />} />
            <Route path="/chemicals" element={<Chemicals />} />
            <Route path="/sitemap" element={<Sitemap />} />
          </Routes>
        </main>
        <WhatsAppButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
